/**
 * Configuração principal do sistema de internacionalização (i18n)
 * 
 * Utiliza i18next com detecção automática de idioma do navegador
 * e persistência da preferência no localStorage.
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importações pt-BR
import ptBRCommon from './locales/pt-BR/common.json';
import ptBRSidebar from './locales/pt-BR/sidebar.json';
import ptBRAuth from './locales/pt-BR/auth.json';
import ptBRPages from './locales/pt-BR/pages.json';
import ptBRHelp from './locales/pt-BR/help.json';

// Importações en-US
import enUSCommon from './locales/en-US/common.json';
import enUSSidebar from './locales/en-US/sidebar.json';
import enUSAuth from './locales/en-US/auth.json';
import enUSPages from './locales/en-US/pages.json';
import enUSHelp from './locales/en-US/help.json';

// Importações es-ES
import esESCommon from './locales/es-ES/common.json';
import esESSidebar from './locales/es-ES/sidebar.json';
import esESAuth from './locales/es-ES/auth.json';
import esESPages from './locales/es-ES/pages.json';
import esESHelp from './locales/es-ES/help.json';

// Recursos de tradução organizados por idioma e namespace
const resources = {
  'pt-BR': {
    common: ptBRCommon,
    sidebar: ptBRSidebar,
    auth: ptBRAuth,
    pages: ptBRPages,
    help: ptBRHelp,
  },
  'en-US': {
    common: enUSCommon,
    sidebar: enUSSidebar,
    auth: enUSAuth,
    pages: enUSPages,
    help: enUSHelp,
  },
  'es-ES': {
    common: esESCommon,
    sidebar: esESSidebar,
    auth: esESAuth,
    pages: esESPages,
    help: esESHelp,
  },
};

// Inicialização do i18next
i18n
  .use(LanguageDetector) // Detecta idioma do navegador automaticamente
  .use(initReactI18next) // Integração com React
  .init({
    resources,
    fallbackLng: 'pt-BR', // Idioma padrão caso não encontre tradução
    defaultNS: 'common', // Namespace padrão
    ns: ['common', 'sidebar', 'auth', 'pages', 'help'], // Namespaces disponíveis
    
    interpolation: {
      escapeValue: false, // React já faz escape por padrão
    },
    
    detection: {
      order: ['localStorage', 'navigator'], // Prioriza localStorage, depois navegador
      caches: ['localStorage'], // Persiste preferência no localStorage
      lookupLocalStorage: 'i18nextLng', // Chave do localStorage
    },
    
    react: {
      useSuspense: false, // Desabilita suspense para evitar loading states
    },
  });

export default i18n;
